@if (stateDescription?.isWorkflowRunning == workflowEnum.none) {
<div class="tab-views">
	@if (hasAP) {
	<span class="tab-view" [class.active]="activeViewState == activeViewStateEnum.AP" id="setViewAP" (click)="setAPView()"
		(keypress)="setAPView()">
		{{ labels().CANVAS_TABSET_COMPONENT_AP_LABEL }}
	</span>
	}
	@if (hasLT) {
	<span class="tab-view" [class.active]="activeViewState == activeViewStateEnum.LT" id="setViewLT" (click)="setLTView()"
		(keypress)="setLTView()">
		{{ labels().CANVAS_TABSET_COMPONENT_LT_LABEL }}
	</span>
	}
	@if (hasAP && hasLT) {
	<span class="tab-view" [class.active]="activeViewState == activeViewStateEnum.multiple" id="setViewMultiple"
		(click)="setMTView()" (keypress)="setMTView()">
		{{ labels().CANVAS_TABSET_COMPONENT_MULTIPLE_LABEL }}
	</span>
	}
</div>
}